import e from "./index13.js";
import t from "./index66.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/colorManipulator/colorManipulator.js
function n(e, n = 0, r = 1) {
	return process.env.NODE_ENV !== "production" && (e < n || e > r) && console.error(`MUI: The value provided ${e} is out of range [${n}, ${r}].`), t(e, n, r);
}
function r(e) {
	e = e.slice(1);
	let t = RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g"), n = e.match(t);
	return n && n[0].length === 1 && (n = n.map((e) => e + e)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((e, t) => t < 3 ? parseInt(e, 16) : Math.round(parseInt(e, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function i(t) {
	if (t.type) return t;
	if (t.charAt(0) === "#") return i(r(t));
	let n = t.indexOf("("), a = t.substring(0, n);
	if (![
		"rgb",
		"rgba",
		"hsl",
		"hsla",
		"color"
	].includes(a)) throw Error(process.env.NODE_ENV === "production" ? e(9, t) : `MUI: Unsupported \`${t}\` color.\nThe following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().`);
	let o = t.substring(n + 1, t.length - 1), s;
	if (a === "color") {
		if (o = o.split(" "), s = o.shift(), o.length === 4 && o[3].charAt(0) === "/" && (o[3] = o[3].slice(1)), ![
			"srgb",
			"display-p3",
			"a98-rgb",
			"prophoto-rgb",
			"rec-2020"
		].includes(s)) throw Error(process.env.NODE_ENV === "production" ? e(10, s) : `MUI: unsupported \`${s}\` color space.\nThe following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.`);
	} else o = o.split(",");
	return o = o.map((e) => parseFloat(e)), {
		type: a,
		values: o,
		colorSpace: s
	};
}
var a = (e) => {
	let t = i(e);
	return t.values.slice(0, 3).map((e, n) => t.type.includes("hsl") && n !== 0 ? `${e}%` : e).join(" ");
}, o = (e, t) => {
	try {
		return a(e);
	} catch {
		return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
	}
};
function s(e) {
	let { type: t, colorSpace: n } = e, { values: r } = e;
	return t.includes("rgb") ? r = r.map((e, t) => t < 3 ? parseInt(e, 10) : e) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), r = t.includes("color") ? `${n} ${r.join(" ")}` : `${r.join(", ")}`, `${t}(${r})`;
}
function c(e) {
	e = i(e);
	let { values: t } = e, n = t[0], r = t[1] / 100, a = t[2] / 100, o = r * Math.min(a, 1 - a), c = (e, t = (e + n / 30) % 12) => a - o * Math.max(Math.min(t - 3, 9 - t, 1), -1), l = "rgb", u = [
		Math.round(c(0) * 255),
		Math.round(c(8) * 255),
		Math.round(c(4) * 255)
	];
	return e.type === "hsla" && (l += "a", u.push(t[3])), s({
		type: l,
		values: u
	});
}
function l(e) {
	e = i(e);
	let t = e.type === "hsl" || e.type === "hsla" ? i(c(e)).values : e.values;
	return t = t.map((t) => (e.type !== "color" && (t /= 255), t <= .03928 ? t / 12.92 : ((t + .055) / 1.055) ** 2.4)), Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3));
}
function u(e, t) {
	let n = l(e), r = l(t);
	return (Math.max(n, r) + .05) / (Math.min(n, r) + .05);
}
function d(e, t) {
	return e = i(e), t = n(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, s(e);
}
function f(e, t, n) {
	try {
		return d(e, t);
	} catch {
		return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
	}
}
function p(e, t) {
	if (e = i(e), t = n(t), e.type.includes("hsl")) e.values[2] *= 1 - t;
	else if (e.type.includes("rgb") || e.type.includes("color")) for (let n = 0; n < 3; n += 1) e.values[n] *= 1 - t;
	return s(e);
}
function m(e, t, n) {
	try {
		return p(e, t);
	} catch {
		return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
	}
}
function h(e, t) {
	if (e = i(e), t = n(t), e.type.includes("hsl")) e.values[2] += (100 - e.values[2]) * t;
	else if (e.type.includes("rgb")) for (let n = 0; n < 3; n += 1) e.values[n] += (255 - e.values[n]) * t;
	else if (e.type.includes("color")) for (let n = 0; n < 3; n += 1) e.values[n] += (1 - e.values[n]) * t;
	return s(e);
}
function g(e, t, n) {
	try {
		return h(e, t);
	} catch {
		return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
	}
}
function _(e, t = .15) {
	return l(e) > .5 ? p(e, t) : h(e, t);
}
function v(e, t, n) {
	try {
		return _(e, t);
	} catch {
		return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
	}
}
//#endregion
export { d as alpha, p as darken, u as getContrastRatio, c as hslToRgb, h as lighten, f as private_safeAlpha, o as private_safeColorChannel, m as private_safeDarken, v as private_safeEmphasize, g as private_safeLighten };

//# sourceMappingURL=index67.js.map